module.exports = __webpack_public_path__ + "static/TakkScroll2-2ba25cd007584a4cc6f9391fc03fbcbf.png";